<mat-card
    class="daxa-card recent-orders-card  border-radius bg-white border-none d-block p-3"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-0 outline-0 rounded-pill "
                       placeholder="Chercher une matrice..." (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <button class="btn btn-primary btn-sm rounded-pill border-0" (click)="openModal(content)">
                <span class="px-2">Nouveau</span>
            </button>
        </mat-card-subtitle>

    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>
                    <!-- select Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox (change)="handleSelectAll()" [checked]="isAllMatricesSelected"/>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox [checked]="isAllMatricesSelected" (change)="handleSelection(element)"/>
                        </td>
                    </ng-container>

                    <!-- Reference Column -->
                    <ng-container matColumnDef="reference">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Référence</th>
                        <td mat-cell *matCellDef="let element"> {{ element.reference }}</td>
                    </ng-container>
                    <ng-container matColumnDef="priseDEssai">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Prise d'Essai (g)</th>
                        <td mat-cell *matCellDef="let element"> {{ element.priseDEssai }} g</td>
                    </ng-container>
                    <!-- Nom Column -->
                    <ng-container matColumnDef="nom">
                        <th mat-header-cell *matHeaderCellDef> Nom</th>
                        <td mat-cell *matCellDef="let element"> {{ element.nom }}</td>
                    </ng-container>
    <!-- Colonne pour les produits réglementaires -->
                    <ng-container matColumnDef="matriceReglementaires">
                        <th mat-header-cell *matHeaderCellDef> Produits réglementaires </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.matriceReglementaireNames }}
                        </td>
                    </ng-container>


                    <!-- Type Column -->
                    <ng-container matColumnDef="type">
                        <th mat-header-cell *matHeaderCellDef> Type</th>
                        <td mat-cell *matCellDef="let element"> {{ element.type }}</td>
                    </ng-container>
    
                    <!-- Description Column -->
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef> Description</th>
                        <td mat-cell *matCellDef="let element"> {{ element.description }}</td>
                    </ng-container>
    
                    <!-- Date de création Column -->
                    <ng-container matColumnDef="creationDate">
                        <th mat-header-cell *matHeaderCellDef> Date de création</th>
                        <td mat-cell *matCellDef="let element"> {{ element.creationDate | date:'yyyy-MM-dd'}}</td>
                    </ng-container>

    
                    <!-- Date de mise à jour Column -->
                    <ng-container matColumnDef="updateDate">
                        <th mat-header-cell *matHeaderCellDef> Date de mise à jour</th>
                        <td mat-cell *matCellDef="let element"> {{ element.updateDate | date:'yyyy-MM-dd' }}</td>
                    </ng-container>
    
                    <!-- Créé par Column -->
                    <ng-container matColumnDef="createdBy">
                        <th mat-header-cell *matHeaderCellDef> Créé par</th>
                        <td mat-cell *matCellDef="let element"> {{ element.createdBy?.username || 'N/A' }}</td>
                    </ng-container>
    
                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Action</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info text-center" style="justify-content: center !important;">
                                <button type="button" mat-button matTooltip="Visualiser les détails"
                                        matTooltipPosition="above" (click)="openViewModel(element.id)">
                                    <i class="material-symbols-outlined">visibility</i>
                                </button>
                                <button type="button" mat-button matTooltip="Modifier" matTooltipPosition="above"
                                        (click)="openEditModal(element.id)">
                                    <i class="material-symbols-outlined text-primary">brush</i>
                                </button>
                                <button type="button" mat-button matTooltip="Supprimer" matTooltipPosition="above"
                                        (click)="confirmDelete(element)">
                                    <i class="material-symbols-outlined text-danger">delete</i>
                                </button>
                            </div>
                        </td>
                    </ng-container>
    
                    <tr mat-header-row *matHeaderRowDef="getdisplayedCol()"></tr>
                    <tr mat-row *matRowDef="let row; columns: getdisplayedCol();"></tr>
    
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="7" *ngIf="!loadingTable">Aucun résultat trouvé pour matrices</td>
                    </tr>
                </table>
                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </mat-card-content>
    
</mat-card>
<!-- modal template for add -->

<ng-template #content let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">
                    Créer une Matrice
                </h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="form" (ngSubmit)="saveMatrice()">
                <div class="row">
                    <!-- Référence -->
                   <div class="col-sm-12 col-md-6">
                         <mat-form-field class="mb-25">
                            <mat-label>Type d'échantillon</mat-label>
                            <input type="text" matInput [formControl]="sampleTypeControl" [matAutocomplete]="auto" placeholder="Rechercher un produit" (focus)="onInputFocus()"/>
                                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayProductName.bind(this)" (optionSelected)="onProductSelected($event)">
                                <mat-option *ngFor="let product of filteredProducts" [value]="product">
                                {{ product.productName }}
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Référence</mat-label>
                            <input matInput formControlName="reference" >
                        </mat-form-field>
                    </div>
                    <!-- Nom -->
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Nom</mat-label>
                            <input matInput formControlName="nom" >
                        </mat-form-field>
                    </div>

                    <!-- Type -->
                    <div class="col-sm-12 col-md-6">
                    <mat-form-field class="mb-25">
                        <mat-label>Type</mat-label>
                        <mat-select formControlName="type">
                        <mat-option *ngFor="let t of types" [value]="t">
                            {{ t }}
                        </mat-option>
                        </mat-select>
                    </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Prise d'Essai (g)</mat-label>
                            <input matInput formControlName="priseDEssai">
                        </mat-form-field>
                    </div>

                    <!-- Description -->
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description" ></textarea>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 text-right mt-3">
                        <button type="submit" class="btn btn-outline-success">Enregistrer</button>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>


<!--modal template for infos -->
<ng-template #viewModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <h5 class="fw-bold mx-3">
            Détails de la Matrice
        </h5>
        <div class="row m-3">
            <div class="col-sm-6 col-lg-4 border-top border-0 p-3">
                <div class="fw-bold">Référence :</div>
                <p>{{ form.get('reference')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Nom :</div>
                <p>{{ form.get('nom')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Produits réglementaires :</div>
                <ul style="list-style-type: none; padding-left: 0; margin: 0;">
                    <li *ngFor="let reg of matriceWithReglementaires?.matriceReglementaires">
                        {{ reg.productName }}
                    </li>
                </ul>
            </div>

            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Type :</div>
                <p>{{ form.get('type')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top border-0 p-3">
                <div class="fw-bold">Prise d'Essai :</div>
                <p>{{ form.get('priseDEssai')?.value }} g</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Description :</div>
                <p>{{ form.get('description')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Date de création :</div>
                <p>{{ form.get('creationDate')?.value | date:'yyyy-MM-dd' }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Date de mise à jour :</div>
                <p>{{ form.get('updateDate')?.value | date:'yyyy-MM-dd' }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Créé par :</div>
                <p>{{ form.get('createdBy')?.value?.username || 'Non renseigné' }}</p>
            </div>

        </div>
    </mat-card>
</ng-template>


<!--Modal template for editing-->
<ng-template #editModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">Modifier Matrice</h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="form" (ngSubmit)="saveUpdatedMatrice()">
                <div class="row">
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Référence</mat-label>
                            <input matInput formControlName="reference" >
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Nom</mat-label>
                            <input matInput formControlName="nom">
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 col-md-6">
                    <mat-form-field class="mb-25">
                        <mat-label>Type</mat-label>
                        <mat-select formControlName="type">
                        <mat-option *ngFor="let t of types" [value]="t">
                            {{ t }}
                        </mat-option>
                        </mat-select>
                    </mat-form-field>
                    </div>

                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Type d'échantillon</mat-label>
                            <input type="text"
                                matInput
                                [formControl]="sampleTypeControl"
                                [matAutocomplete]="auto"
                                placeholder="Rechercher un produit"
                                (focus)="onInputFocus()"/>
                            <mat-autocomplete #auto="matAutocomplete" 
                                            [displayWith]="displayProductName.bind(this)" 
                                            (optionSelected)="onProductSelected($event)">
                            <mat-option *ngFor="let product of filteredProducts" [value]="product">
                                {{ product.productName }}
                            </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                        <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Prise d'Essai (g)</mat-label>
                            <input matInput formControlName="priseDEssai" >
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-25">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description"></textarea>
                        </mat-form-field>
                    </div>

                </div>

                <div class="col-sm-12 text-right mt-3">
                    <button type="submit" class="btn btn-outline-success">Enregistrer</button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>
